
import { ActionTypes } from "../../stores/action-types";
import { defineComponent } from "vue";
import RadioButton from "../Components/RadioButton.vue";
import { useStore } from "../../stores";

interface Props {
  isUsed: string;
}

export default defineComponent({
  name: "RoomCard",

  props: {
    roomId: { type: String, required: true },
    roomName: { type: String, required: true },
    roomPlayersCount: { type: Number, required: true },
  },

  computed: {
    buttonText: ({ isUsed }: Props) => (isUsed ? 'Using' : 'Use'),
  },

  methods: {
    onSelectRoom(roomId: string): void {
      const store = useStore();
      store.dispatch(ActionTypes.SELECT_ROOM, roomId);
    },
  },

  components: { RadioButton },
});
